// src/components/common/PasswordInput.js

import React, { useState } from 'react';

export default function PasswordInput({ id, name, value, onChange, placeholder, className, ...props }) {
    const [isVisible, setIsVisible] = useState(false);
    return (
        <div className="relative w-full">
            <input 
                id={id} 
                name={name} 
                type={isVisible ? 'text' : 'password'} 
                value={value} 
                onChange={onChange} 
                placeholder={placeholder} 
                className={className || "w-full bg-slate-700 border border-slate-600 rounded-md p-2 pr-10 focus:ring-2 focus:ring-cyan-400 focus:outline-none"}
                {...props}
            />
            <button type="button" onClick={() => setIsVisible(!isVisible)} className="absolute inset-y-0 right-0 flex items-center px-3 text-slate-400 hover:text-cyan-300">
                {isVisible ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7 1.274-4.057 5.064-7 9.542-7 .847 0 1.67.127 2.455.364m0 12.291A9.959 9.959 0 0021.542 12c-1.274-4.057-5.064-7-9.542-7a9.953 9.953 0 00-4.293 1.175M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
                    </svg>
                )}
            </button>
        </div>
    );
}